import React from 'react';
import { Trash2 } from 'lucide-react';

function DeleteUserModal({ user, onClose, onDelete }) {
  const handleDelete = () => {
    onDelete(user.id);
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 16,
    }}>
      <div className="card animate-in" style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2 className="font-heading" style={{ fontSize: 20, color: 'var(--accent-red)' }}>Delete User</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: 20 }}>✕</button>
        </div>

        <div style={{ textAlign: 'center', padding: '16px 0' }}>
          <div style={{
            width: 64, height: 64, borderRadius: '50%',
            background: 'rgba(232,0,29,0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px', color: 'var(--accent-red)',
          }}>
            <Trash2 size={28} />
          </div>
          <p style={{ color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.6 }}>
            Are you sure you want to delete <strong style={{ color: 'var(--text-primary)' }}>{user.name}</strong>?
            <br />This action cannot be undone.
          </p>
        </div>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 20 }}>
          <button className="btn-secondary" onClick={onClose}>Cancel</button>
          <button
            onClick={handleDelete}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '9px 20px', background: 'rgba(232,0,29,0.85)',
              color: '#fff', border: 'none', borderRadius: 'var(--radius-sm)',
              fontFamily: 'JetBrains Mono, monospace', fontWeight: 600, fontSize: 14,
              cursor: 'pointer', transition: 'var(--transition)',
            }}
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteUserModal;